import React, { Component } from 'react'

class IconSad extends Component {
  render() {
    return (
      <svg width="68" height="68">
        <g fill="#B13D47">
          <path d="M49.9 47.38c-.239-.301-5.936-7.387-15.9-7.387S18.34 47.078 18.101 47.38l4.173 3.288c.042-.054 4.31-5.363 11.726-5.363 7.324 0 11.558 5.154 11.735 5.374l-.009-.011L49.9 47.38z" />
          <path
            fillRule="evenodd"
            d="M34 0c9.082 0 17.62 3.537 24.042 9.958C64.463 16.38 68 24.918 68 34s-3.537 17.62-9.958 24.042C51.62 64.463 43.082 68 34 68s-17.62-3.537-24.042-9.958C3.537 51.62 0 43.082 0 34S3.537 16.38 9.958 9.958C16.38 3.537 24.918 0 34 0zM5.312 34c0 15.818 12.87 28.688 28.688 28.688S62.688 49.818 62.688 34 49.818 5.312 34 5.312 5.312 18.182 5.312 34z"
            clipRule="evenodd"
          />
          <path d="M22.313 28.172a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5zM45.688 28.172a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5z" />
        </g>
      </svg>
    )
  }
}

export default IconSad



// WEBPACK FOOTER //
// ./src/svg/icon-sad.js